import { tenant } from '@/utils/urlGenerator'
import { init, setTag } from '@sentry/browser'

const sentryDSN = document.querySelector('meta[name=sentry_dsn]').content
const environment = document.querySelector('meta[name=env]').content
const version = document.querySelector('meta[name=version]').content

if (sentryDSN) {
  init({
    environment: environment,
    dsn: sentryDSN,
    ignoreErrors: [
      'Request failed with status code 422', // Validation
      'Request failed with status code 404', // Not found
      'Request failed with status code 403', // Permission denied
      'Request failed with status code 401' // Unauthorized
    ],
    release: `edlus@${version}`
  })
}

export const setSentryContext = () => {
  setTag('tenant', tenant())
}
